<template>
  <v-menu
    v-if="mini"
    close-delay="50"
    close-on-content-click
    nudge-right="5"
    nudge-width="200px"
    offset-x
    open-on-hover
    right
    :rounded="false"
  >
    <template v-slot:activator="{ on }">
      <v-list-item
        class="sidebar-item"
        link
        :ripple="false"
        :to="item.router"
        v-on="on"
      >
        <v-list-item-icon>
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </template>
    <v-card flat tile width="200px">
      <v-list class="pa-0" dense>
        <v-list-item dark style="background: #84a2ae">
          <v-list-item-title>
            <trans-field transable :value="item"></trans-field>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="subItem in children"
          :key="subItem.name"
          class="sidebar-item"
          :title="subItem.name"
          :to="subItem.router"
        >
          <v-list-item-icon>
            <v-icon>
              {{ subItem.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <trans-field transable :value="subItem"></trans-field>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
  <v-list-group v-else v-model="p_model" append-icon="" :no-action="!mini">
    <template v-if="item.icon" #appendIcon>
      <v-icon>
        {{ p_model ? 'mdi-menu-up' : 'mdi-menu-down' }}
      </v-icon>
    </template>
    <template #prependIcon>
      <v-icon v-if="item.icon">{{ item.icon || 'mdi-apps' }}</v-icon>
      <v-icon v-else>
        {{ p_model ? 'mdi-menu-up' : 'mdi-menu-down' }}
      </v-icon>
    </template>
    <template v-slot:activator>
      <v-list-item-title>
        <trans-field transable :value="item"></trans-field>
      </v-list-item-title>
    </template>
    <v-list-item
      v-for="child in children"
      :key="child.text"
      class="pl-12 sidebar-item"
      exact
      link
      :to="child.router"
    >
      <v-list-item-icon>
        <v-icon>{{ child.icon || 'mdi-apps' }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          <trans-field transable :value="child"></trans-field>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list-group>
</template>

<script>
export default {
  props: {
    mini: Boolean,
    item: { required: true, type: Object },
    children: { required: true, type: Array },
  },
  data: () => ({ p_model: false }),
  watch: {
    item: {
      handler(value) {
        this.p_model = value.model
      },
      immediate: true,
    },
  },
}
</script>

<style></style>
